import { AGGWTransport, AGTransport, } from "@agrigate/shared/lib/rpc/clients";
import { ensureNN } from "@agrigate/ts-utils/lib/coercions";
import { thruUnlessN } from "@agrigate/ts-utils/lib/nullability";
import { rpcClient } from "@lorefnon/ts-json-rpc/lib/client";
export const getClients = (opts, interceptors) => {
    console.debug("RPC client opts:", opts);
    const transports = {
        backend: thruUnlessN(opts.backend, _ => new AGTransport(_)),
        gateway: thruUnlessN(opts.gateway, _ => new AGGWTransport(_)),
    };
    const clientOpts = (name, entryPoint = "backend") => {
        if (transports[entryPoint]) {
            return {
                transport: ensureNN(transports[entryPoint], "service entry point"),
                meta: { name },
                onError: interceptors?.onError,
                onStart: interceptors?.onStart,
                onEnd: interceptors?.onEnd,
                onSuccess: interceptors?.onSuccess,
            };
        }
        throw new Error("RPC client: Invalid Service Type Registration");
    };
    const client = (name, service = "backend") => rpcClient(clientOpts(name, service));
    return {
        client,
        translations: client("translations"),
        location: client("location"),
        userProfile: client("user-profile"),
        users: client("users"),
        empGeoScopes: client("emp-geo-scopes"),
        // methods.ts not found
        aadhaarVerification: client("aadhaar-verification"),
        alerts: client("alerts"),
        auth: client("auth"),
        produceTypes: client("produce-types"),
        produceTypeCategories: client("produce-type-categories"),
        produceBatches: client("produce-batches"),
        payouts: client("payouts"),
        buyerOrders: client("buyer-orders"),
        purchaseOrders: client("purchase-orders"),
        profileTypes: client("profile-types"),
        notification: client("notification"),
        settings: client("settings"),
        customerSupport: client("customer-support/core", "gateway"),
        feed: {
            /* core: client<FeedService>("feed"),
            engagement: client<FeedEngagementService>("feed-engagement"), */
            core: client("feed/core", "gateway"),
            engagement: client("feed/engagement", "gateway"),
            notifyer: client("feed-notifyer"),
            categories: client("feed-categories"),
            visitors: client("feed-visitors"),
        },
        earnings: client("earnings"),
        invoices: client("invoices"),
        // methods.ts not found
        transactionImport: client("transaction-import"),
        deliveryTracks: client("delivery-tracks"),
        deliveryTrackStops: client("delivery-track-stop"),
        contentSync: client("content-sync"),
        bankAccounts: client("bank-accounts"),
        payoutAccounts: client("payout-accounts"),
        trustedUsers: client("trusted-users"),
        // methods.ts not found
        reporting: client("reporting"),
        // methods.ts not found
        stash: client("stash"),
        // methods.ts not found
        notificationPreferences: client("notification-preferences"),
        transactions: client("transactions"),
        userFeatures: client("user-feature"),
        cache: client("cache"),
        extIdSeq: client("ext-id-seq"),
        shipments: client("shipments"),
        // methods.ts not found
        inventory: client("inventory"),
        collectionTargets: client("collection-targets"),
        cpBalance: client("cp-balance"),
        cpSchedule: client("cp-schedule"),
        reimbursementRequest: client("reimbursement-request"),
        // methods.ts not found
        internalMailer: client("internal-mailer"),
        // methods.ts not found
        priceTracker: client("price-tracker"),
        // methods.ts not found
        employeeTracking: client("employee-track"),
        apiKeys: client("api-keys"),
        // methods.ts not found
        demandSpeculations: client("demand-speculations"),
        collectionCenter: client("collection-center"),
        cpCommissions: client("cp-commissions"),
        cpIncentiveConfig: client("cp-incentive-config"),
        channelPartners: client("channel-partner"),
        notificationTemplate: client("notification-template"),
        superpower: client("superpower"),
        pg: client("pg"),
        // methods.ts not found
        zoho: client("zoho-sync"),
        zohoUserSync: client("zoho-user-sync"),
        zohoPayments: client("zoho-payments"),
        evtInterest: client("event-interest"),
        surveys: client("survey/surveys", "gateway"),
        rewards: client("rewards"),
        rewardTransactions: client("reward-transactions"),
        rewardSources: client("reward-sources"),
        rewardRedemptions: client("reward-redemptions"),
        reputationTiers: client("reputation-tiers"),
        reputation: client("reputation"),
        cluster: client("cluster"),
        weather: client("weather", "gateway"),
        insurance: {
            plans: client("insurance/plans", "gateway"),
            policies: client("insurance/policies", "gateway"),
            providers: client("insurance/providers", "gateway"),
            applications: client("insurance/applications", "gateway"),
            categories: client("insurance/categories", "gateway"),
            claim: client("insurance/claims", "gateway"),
            banners: client("insurance/banners", "gateway"),
        },
        marketplace: {
            product: client("marketplace/product", "gateway"),
            sku: client("marketplace/sku", "gateway"),
            order: client("marketplace/order", "gateway"),
            batchOrder: client("marketplace/batch-order", "gateway"),
            brand: client("marketplace/brand", "gateway"),
            productCategory: client("marketplace/product-category", "gateway"),
            banner: client("marketplace/banner", "gateway"),
            pricingConfig: client("marketplace/pricing-config", "gateway"),
            inventory: client("marketplace/inventory", "gateway"),
            shipment: client("marketplace-shipment"),
        },
        actions: client("actions"),
        resourceAccess: client("resource-access"),
        equipment: {
            categories: client("equipment/categories", "gateway"),
            // brands: client<EquipmentBrandsService>("equipment/brands", "gateway"),
            machines: client("equipment/machines", "gateway"),
            models: client("equipment/models", "gateway"),
            booking: client("equipment/booking", "gateway"),
            pricing: client("equipment/pricing", "gateway"),
            plot: client("equipment/plot", "gateway"),
            serviceSession: client("equipment/service-session", "gateway"),
            payments: client("equipment/payments", "gateway"),
        },
        docApproval: client("doc-approval"),
        // methods.ts not found
        dBankSearchResults: client("feed/search-results", "gateway"),
        // methods.ts not found
        dBankSearchTopics: client("feed/search-topics", "gateway"),
        // methods.ts not found
        dBankSearchEngines: client("feed/search-engines", "gateway"),
        // methods.ts not found
        dBankSuggestedTopics: client("feed/suggested-topics", "gateway"),
        soilTestingTests: client("soil-testing/tests", "gateway"),
        soilTestingBrands: client("soil-testing/brands", "gateway"),
        soilTestingBooking: client("soil-testing/booking", "gateway"),
        soilTestingReports: client("soil-testing/reports", "gateway"),
        soilTestingPricingConfig: client("soil-testing/pricing-config", "gateway"),
        discounts: client("discounts"),
        reports: {
            orderAggrs: client("reporting-api/order-aggregates", "gateway"),
            userAggrs: client("reporting-api/user-aggregates", "gateway"),
            shipmentAggrs: client("reporting-api/shipment-aggregates", "gateway"),
            clusterAggrs: client("reporting-api/cluster-aggregates", "gateway"),
            filters: client("filters", "gateway"),
            bgJobs: client("reporting-api/background-jobs", "gateway"),
            dashMetrics: client("reporting-api/dashboard-metric", "gateway"),
            insuranceAggrs: client("reporting-api/insurance-aggregates", "gateway"),
            bookingAggrs: client("reporting-api/booking-aggregates", "gateway"),
            marketplaceAggrs: client("reporting-api/marketplace-aggregates", "gateway"),
            soilTestingAggrs: client("reporting-api/soil-testing-aggregates", "gateway"),
            aiTokenAggrs: client("reporting-api/ai-token-usage", "gateway"),
            investorReports: client("reporting-api/investor-reports", "gateway"),
            aggregator: client("reporting-api/aggregator", "gateway"),
            metrics: client("reporting-api/reporting-metrics", "gateway"),
        },
    };
};
//# sourceMappingURL=index.js.map